<template>
  <section class="app-main">
    <transition
      name="fade"
      mode="out-in">
      <router-view :key="key"/>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.name ? this.$route.name + +new Date() : this.$route + +new Date();
    }
  }
};
</script>
<style lang="less" scoped>
.app-main{
  background: rgb(26,28,42);
  height: cacl(100vh - 74px);
  overflow: hidden;
  overflow-y: auto;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/AppMain.vue?b9ee5528